import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

export const fetchFGStatusesAPI = async () => {
  return {
    projectStatuses: [
      { status_id: 1, status_name: "Created", activated: false },
      { status_id: 2, status_name: "Initiated", activated: false },
      { status_id: 3, status_name: "In-Progress", activated: true },
      { status_id: 4, status_name: "Completed", activated: true },
      { status_id: 5, status_name: "On-Hold", activated: true },
      { status_id: 6, status_name: "Cancelled", activated: true },
      { status_id: 7, status_name: "Closed", activated: true },
    ],
    poStatuses: [
      { status_id: 1, status_name: "Created", activated: false },
      { status_id: 2, status_name: "New PO", activated: false },
      { status_id: 3, status_name: "Under Confirmation", activated: true },
      { status_id: 4, status_name: "Confirmed", activated: true },
      { status_id: 5, status_name: "Changes Under Review", activated: true },
      { status_id: 6, status_name: "Changed", activated: true },
      { status_id: 7, status_name: "Delivery Complete", activated: false },
    ],
    campaignStatuses: [
      { status_id: 1, status_name: "Ongoing", activated: true },
      { status_id: 2, status_name: "Complete", activated: true },
      { status_id: 3, status_name: "Delayed", activated: true },
      { status_id: 4, status_name: "Pending", activated: true },
      { status_id: 5, status_name: "Inactive", activated: true },
    ],
    batchStatuses: [
      { status_id: 1, status_name: "Production Complete", activated: true },
      { status_id: 2, status_name: "CMO QC Released", activated: true },
      { status_id: 3, status_name: "Post Manufacturing Digitalized Data Validated", activated: true },
      { status_id: 4, status_name: "Stock Check Not Required", activated: true },
      { status_id: 5, status_name: "Material Not Expired", activated: true },
      { status_id: 6, status_name: "Consumption Specs Not Matching", activated: true },
      { status_id: 7, status_name: "Consumption Approved", activated: true },
      { status_id: 8, status_name: "Pre-Shipment Documents Uploaded", activated: true },
      { status_id: 9, status_name: "Pre-Shipment Digitalized Data Validated", activated: true },
      { status_id: 10, status_name: "Pre-IBD Check Completed", activated: true },
      { status_id: 11, status_name: "GRN Generated", activated: true },
      { status_id: 12, status_name: "Batch Released By Sponsor QA", activated: true },
      { status_id: 13, status_name: "Batch Not Accepted", activated: true },
      { status_id: 14, status_name: "CMO ASN Completed", activated: true },
      { status_id: 15, status_name: "Post-Shipment Documents Uploaded", activated: true },
      { status_id: 16, status_name: "Post-Shipment Digitalized Data Validated", activated: true },
      { status_id: 17, status_name: "IBD Generated", activated: true },
    ],
  };
};

export const saveStatusSelectionAPI = async (statusData) => {
  return {
    success: true,
    message: "Status selection saved successfully",
    data: statusData,
  };
};

export const saveCampaignIDAPI = async (campaignData) => {
  return {
    success: true,
    message: "Campaign ID saved successfully",
    data: campaignData,
  };
};

export const saveColumnConfigurationsAPI = async (columnConfigData) => {
  return {
    success: true,
    message: "Column configurations saved successfully",
    data: columnConfigData,
  };
};

// Real API functions for Project Development
export const updateProjectDetailsAPI = async (payload) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");
  
  if (!appName || !network || !collabType || !roleName) {
    throw new Error("Missing required localStorage values for API call");
  }
  
  const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  const response = await axios.post(`${apiBaseUrl}/updateProjectDetails`, payload);
  return response.data;
};

export const updateProjectStatusesAPI = async (payload) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");
  
  if (!appName || !network || !collabType || !roleName) {
    throw new Error("Missing required localStorage values for API call");
  }
  
  const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  const response = await axios.post(`${apiBaseUrl}/updateProjectStatuses`, payload);
  return response.data;
};

export const updateProjectDocumentDeliverablesAPI = async (payload) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");
  
  if (!appName || !network || !collabType || !roleName) {
    throw new Error("Missing required localStorage values for API call");
  }
  
  const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  const response = await axios.post(`${apiBaseUrl}/updateProjectDocumentDeliverables`, payload);
  return response.data;
};

export const updateCampaignDetailsAPI = async (payload) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");
  
  if (!appName || !network || !collabType || !roleName) {
    throw new Error("Missing required localStorage values for API call");
  }
  
  const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  const response = await axios.post(`${apiBaseUrl}/updateCampaignDetails`, payload);
  return response.data;
};

// Fetch Project Details API - Used when editing a project
export const fetchProjectDetailsAPI = async (collabrixProjectID) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");
  
  if (!appName || !network || !collabType || !roleName) {
    throw new Error("Missing required localStorage values for API call");
  }
  
  if (!collabrixProjectID) {
    throw new Error("collabrixProjectID is required");
  }
  
  const apiBaseUrl = `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  const response = await axios.get(`${apiBaseUrl}/fetchProjectDetails/${collabrixProjectID}`);
  return response.data;
};

// Legacy functions for backward compatibility
export const submitProductDevelopmentAPI = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  const mockResponse = {
    success: true,
    status: true,
    message: "Product development project submitted successfully",
    data: formData,
    projectId: "PROJ_" + Date.now(),
  };

  return mockResponse;
};

export const updateProductDevelopmentAPI = async (formData) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  const mockResponse = {
    success: true,
    status: true,
    message: "Product development project updated successfully",
    data: formData,
  };

  return mockResponse;
};

export const fetchDocumentTypesAPI = async () => {
  return {
    documentTypesList: [
      { documentTypeID: 1, documentTypeName: "Sample Plan" },
      { documentTypeID: 2, documentTypeName: "BoM" },
      { documentTypeID: 3, documentTypeName: "BMR" },
      { documentTypeID: 4, documentTypeName: "MBR" },
      { documentTypeID: 5, documentTypeName: "List Of Tests" },
      { documentTypeID: 6, documentTypeName: "Change Controls" },
      { documentTypeID: 7, documentTypeName: "Deviations" },
      { documentTypeID: 8, documentTypeName: "GRN" },
    ],
  };
};

export const fetchFileFormatTypesAPI = async () => {
  return {
    fileFormatTypesList: [
      { fileFormatTypeID: 1, fileFormatTypeName: ".pdf" },
      { fileFormatTypeID: 2, fileFormatTypeName: ".xml" },
      { fileFormatTypeID: 3, fileFormatTypeName: ".xlsx" },
      { fileFormatTypeID: 4, fileFormatTypeName: ".json" },
      { fileFormatTypeID: 5, fileFormatTypeName: ".idoc" },
    ],
  };
};

export const fetchCollaboratorTypesAPI = async () => {
  return [
    { collaborator_type_id: 1, collaborator_type_name: "CMO" },
    { collaborator_type_id: 2, collaborator_type_name: "Sponsor" },
    { collaborator_type_id: 3, collaborator_type_name: "Both" },
  ];
};

export const saveDocumentDeliverablesAPI = async (documentData) => {
  return {
    success: true,
    message: "Document deliverables saved successfully",
    data: documentData,
  };
};

export const fetchStageMappingAPI = async () => {
  return [
    {
      stageNumber: 1,
      sponsorStageID: "BMT-123456",
      cmoStageID: "A",
      selected: true,
    },
    {
      stageNumber: 2,
      sponsorStageID: "BMT-123457",
      cmoStageID: "B",
      selected: true,
    },
    {
      stageNumber: 3,
      sponsorStageID: "BMT-123458 (Caffeine 4B)",
      cmoStageID: "C",
      selected: true,
    },
    {
      stageNumber: 4,
      sponsorStageID: "BMT-123459",
      cmoStageID: "D",
      selected: true,
    },
    {
      stageNumber: 5,
      sponsorStageID: "BMT-123450",
      cmoStageID: "E",
      selected: true,
    },
  ];
};

